export default {
  init() {
    let btnPrev = $('.section-timeline-nav__prev');
    let btnNext = $('.section-timeline-nav__next');
    let container = $('.timeline__wrap');
    let containerWidth = container.width();
    let svg = $('.timeline__wrap svg');

    $(document).on('scroll resize load', function() {
      if($('.timeline').length > 0) {
        horizontalPosition();
      }
    });

    btnPrev.on('click', function() {
      var far = containerWidth;
      var pos = $('.timeline').scrollLeft();
      $('.timeline').animate( { scrollLeft: pos + far}, {
        duration: 1000,
        complete: function() {
          horizontalPosition();
        }
      });
    });

    btnNext.on('click', function() {
      var far = containerWidth;
      var pos = $('.timeline').scrollLeft();
      $('.timeline').animate( { scrollLeft: pos - far }, {
        duration: 1000,
        complete: function() {
          horizontalPosition();
        }
      });
    });

    function horizontalPosition() {

      var scrolLeft = $(window).scrollLeft();
      var windw = $('.timeline').width();//important
      var documet = $('.timeline__wrap svg').width();
      
      if($('.timeline').scrollLeft() + windw == documet){
        $('.section-timeline-nav__prev').addClass('disabled');
      } else {
        $('.section-timeline-nav__prev').removeClass('disabled');
      }

      if(svg.offset().left == 50){
        $('.section-timeline-nav__next').addClass('disabled');
      } else {
        $('.section-timeline-nav__next').removeClass('disabled');
      }
    }
  }
}
